<template>
  <section id="about">
    <v-sheet class="about" color="third">
      <div class="py-12" ></div>

      <v-container class="text-center">
<!--        <h2 class="display-2 font-weight-bold mb-3 text&#45;&#45;text">{{ $t('menuAbout') }}</h2>-->

        <v-responsive class="mx-auto mb-8" width="56">


        </v-responsive>
        <v-row>
          <v-col class="d-flex justify-center align-center">
            <v-avatar class="align-center" size="128">
              <v-img src="../assets/azi_picture.jpeg"></v-img>
            </v-avatar>
          </v-col>
        </v-row>
        <v-responsive class="mx-auto mb-8 aboutTextContainer" >
          <div class="font-weight-light my-12 aboutText">{{ $t('aboutText') }}</div>
        </v-responsive>
        <v-row>
          <v-col class="d-flex justify-center align-center">
            <v-btn
                v-for="icon in icons"
                :key="icon"
                class="mx-3"
                dark
                icon
            >
              <a class="icon" :href="icon.url"><v-icon large >{{ icon.name }}</v-icon></a>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </v-sheet>
  </section>
</template>

<script>
export default {
  name: "Team",
  data: () => {
    return {
      members: [
        {
          icon: "mdi-home",
          title: "Solution Architect",
          text: 'aboutText',
        }
      ],
      icons: [
        {
          name:'mdi-linkedin',
          url: 'https://www.linkedin.com/in/alexandro-lahmann',
        },
        {
          name:'mdi-xing',
          url: 'https://www.xing.com/profile/Alexandro_Lahmann',
        },
        {
          name:'mdi-twitter',
          url: 'https://twitter.com/_alahmann',
        },
      ]
    };
  }
};
</script>

<style scoped>
.icon {
  text-decoration: none;
}
.aboutText {
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: .009375em
 }
.aboutTextContainer {
  max-width: 60%;
  alignment: center;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .aboutTextContainer {
    max-width: 80%;
  }
}

</style>